export default __webpack_public_path__ + "static/media/LoginBackground.efe2ccff.png";